import * as routeConstants from "./RouteConstants";
import * as accessScopeConstants from "./AccessScopeConstants";
import * as menuConstants from "./MenuConstants";
import * as learningObjectConstants from "./LearningObjectConstants";
import * as globalConstants from "./GlobalConstants";
import * as learningProgramConstants from "./LearningProgramConstants";
import * as notificationConstants from "./NotificationConstants";
import * as integrationConstants from "./IntegrationConstants";
import * as rewardConstants from "./RewardConstants";
import * as savedReportConstants from "./SavedReportConstants";
import * as userUploadConstants from "./UserUploadConstants";

export const RouteConstants = routeConstants;
export const AccessScopeConstants = accessScopeConstants;
export const MenuConstants = menuConstants;
export const LearningObjectConstants = learningObjectConstants;
export const GlobalConstants = globalConstants;
export const LearningProgramConstants = learningProgramConstants;
export const NotificationConstants = notificationConstants;
export const IntegrationConstants = integrationConstants;
export const RewardConstants = rewardConstants;
export const SavedReportConstants = savedReportConstants;
export const UserUploadConstants = userUploadConstants;
